import { Image } from "~/components/reusable/Image"

import { extractInitials, getTextColor, stringToColor } from "~/utils/avatarUtils"
import { cn } from "~/utils/helpers"

interface UserAvatarProps {
  name: string
  email: string
  picture?: string
  size?: number
  className?: string
}

export function UserAvatar({ name, email, picture, size = 36, className }: UserAvatarProps) {
  const label = name || email
  const bg = stringToColor(label)

  return (
    <div
      className={cn("relative shrink-0 overflow-hidden rounded-full shadow-base", className)}
      style={{ width: size, height: size }}
    >
      <div
        className="absolute inset-0 flex items-center justify-center font-medium"
        style={{ backgroundColor: bg, color: getTextColor(bg), fontSize: size * 0.4 }}
      >
        {extractInitials(label)}
      </div>
      {picture && (
        <div className="absolute inset-0">
          <Image src={picture} alt={label} width={size} height={size} />
        </div>
      )}
    </div>
  )
}
